import PropTypes from 'prop-types';
import React, {Component} from 'react';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import {CustomSvgIcon} from 'crazyEditor/components/EditorUI/BaseUI/index';
import _ from 'lodash';
import {minusCircle, warning, info, checkCircle} from 'shared/icons';
import ChildrenFader from 'shared/components/ChildrenFader';
import transitions from 'material-ui/styles/transitions';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'left',
    transition: 'height 350ms cubic-bezier(0.23, 1, 0.32, 1)',
    padding: 20,
    boxSizing: 'border-box',
  },
  infoBoxIcon: {
    fontSize: 30,
    marginRight: 15,
    width: 24,
  },
};

export const LEVEL_INFO = 'info';
export const LEVEL_NOTICE = 'notice';
export const LEVEL_ERROR = 'error';
export const LEVEL_WARNING = 'warning';

export const WARNING_TEXT_COLOR = Colors.yellow800;

export const getColorStyle = level => {
  let color;
  let backgroundColor;
  switch (level) {
    case LEVEL_ERROR:
      color = Colors.red900;
      backgroundColor = Colors.red50;
      break;
    case LEVEL_INFO:
      color = Colors.lightGreen800;
      backgroundColor = Colors.lightGreen50;
      break;
    case LEVEL_NOTICE:
      color = Colors.blue700;
      backgroundColor = Colors.blue50;
      break;
    case LEVEL_WARNING:
      color = WARNING_TEXT_COLOR;
      backgroundColor = Colors.yellow50;
      break;
    default:
      break;
  }
  return {
    color,
    backgroundColor,
  };
};

export default class InlineNotification extends Component {
  render() {
    const {easyTransitionPath, level, animate, open, style, onRequestClose, icon} = this.props;
    let {children, id} = this.props;
    let {iconPath, color, backgroundColor} = this.props;
    const rootStyles = _.clone(styles.root);

    const noticeColors = getColorStyle(level);
    color = color || noticeColors.color;
    backgroundColor = backgroundColor || noticeColors.backgroundColor;
    switch (level) {
      case LEVEL_ERROR:
        iconPath = iconPath || warning;
        break;
      case LEVEL_INFO:
        iconPath = iconPath || checkCircle;
        break;
      case LEVEL_NOTICE:
        iconPath = iconPath || info;
        break;
      case LEVEL_WARNING:
        iconPath = iconPath || warning;
        break;
      default:
        break;
    }
    if (!animate) {
      rootStyles.transition = null;
    }
    let content;
    children = React.Children.map(children, (child, index) => {
      if (_.get(child, 'props.style.color') === 'inherit') {
        child = React.cloneElement(child, {style: {...child.props.style, color}});
      }
      return child;
    });
    if (animate) {
      content = (
        <ChildrenFader
          enterStyle={{transform: 'translateY(-50px)', opacity: 0}}
          leaveStyle={{transform: 'translateY(50px)', opacity: 0}}
          transitionDurationMs={animate ? 350 : 0}
          path={easyTransitionPath || children || ''}
        >
          {children}
        </ChildrenFader>
      );
    } else {
      content = children;
    }
    id = id ? id : 'cla-inline-notification';
    return (
      <div
        id={id}
        style={{
          color,
          backgroundColor,
          overflow: 'hidden',
          ...styles.root,
          ...style,
          height: open ? style.height : 0,
          paddingTop: open ? styles.root.padding : 0,
          paddingBottom: open ? styles.root.padding : 0,
          transition: transitions.easeOut(),
        }}
      >
        {icon ? (
          <span style={styles.infoBoxIcon}>{icon}</span>
        ) : (
          iconPath && <CustomSvgIcon height={30} width={30} style={styles.infoBoxIcon} color={color} path={iconPath} />
        )}
        <div id={`${id}-content`} style={{flexGrow: 1}}>
          {content}
        </div>
        {onRequestClose && (
          <IconButton
            style={{paddingRight: 0}}
            iconStyle={{color: color}}
            onClick={() => {
              onRequestClose();
            }}
          >
            <FontIcon className="material-icons cla-close">close</FontIcon>
          </IconButton>
        )}
      </div>
    );
  }
}

InlineNotification.propTypes = {
  children: PropTypes.node,
  onRequestClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  animate: PropTypes.bool,
  iconPath: PropTypes.string,
  level: PropTypes.oneOf([LEVEL_ERROR, LEVEL_INFO, LEVEL_NOTICE, LEVEL_WARNING]),
  easyTransitionPath: PropTypes.any,
  icon: PropTypes.node,
};

InlineNotification.defaultProps = {
  style: {},
  open: true,
  animate: false,
  level: LEVEL_INFO,
};
